var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "City",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-city-7948156",
    transform: "translate(-29.599 20.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M21.13,8.332a.5.5,0,0,0-.5.5v1.487h-.991A1.494,1.494,0,0,0,18.155,11.8v.5a1.5,1.5,0,0,0-1.487,1.487V26.677a1.5,1.5,0,0,0,1.487,1.487H31.046a1.5,1.5,0,0,0,1.487-1.487V17.753a1.5,1.5,0,0,0-1.488-1.487H25.592V13.786A1.5,1.5,0,0,0,24.105,12.3v-.5a1.5,1.5,0,0,0-1.487-1.487h-.992V8.828a.5.5,0,0,0-.5-.5Zm-1.487,2.975h2.975a.488.488,0,0,1,.5.5v.5H19.146v-.5a.489.489,0,0,1,.5-.5Zm-.5,3.967h3.967a.5.5,0,0,1,0,.992H19.146a.5.5,0,0,1,0-.992Zm6.445,1.983h5.454a.488.488,0,0,1,.5.5v8.924a.487.487,0,0,1-.5.5h-.5V24.693a.5.5,0,0,0-.5-.5H27.08a.5.5,0,0,0-.5.5v2.479h-.992Zm-6.445.992h3.967a.5.5,0,1,1,0,.991H19.146a.5.5,0,1,1,0-.991Zm0,2.975h3.967a.5.5,0,1,1,0,.991H19.146a.5.5,0,1,1,0-.991Zm0,2.975h3.967a.5.5,0,1,1,0,.991H19.146a.5.5,0,1,1,0-.991Z",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M58.829,62.5a.5.5,0,0,0-.5.5v.992a.5.5,0,1,0,.992,0V63a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-31.749 -41.277)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M71.329,62.5a.5.5,0,0,0-.5.5v.992a.5.5,0,1,0,.992,0V63a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-41.274 -41.277)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M58.829,50a.5.5,0,0,0-.5.5v.992a.5.5,0,1,0,.992,0V50.5a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-31.749 -31.752)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M71.329,50a.5.5,0,0,0-.5.5v.992a.5.5,0,1,0,.992,0V50.5a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-41.274 -31.752)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityCard);
export default __webpack_public_path__ + "static/media/CityCard.caeb3400844ff310ccca295b29015ade.svg";
export { ForwardRef as ReactComponent };